import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import { useDispatch } from 'react-redux';
import { MENUS } from 'src/contents/DynamicConstant';
import actions from 'src/redux/actions';
import CustomMenuItem from 'src/components/2.2.0/layout/CustomMenuItem';

export default function MenuLogin() {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(actions.logout());
  };

  return (
    <Paper style={{ width: 255, fontWeight: 700 }}>
      <List component="nav" dense>
        {MENUS.map((item, index) => (
          <CustomMenuItem
            key={index}
            routeProps={item}
            callback={() => {
              if (!item.href) handleLogout();
            }}
          />
        ))}
      </List>
    </Paper>
  );
}
